import { render } from "./DocumentosMovimiento.vue?vue&type=template&id=33e8f99a"
import script from "./DocumentosMovimiento.vue?vue&type=script&lang=js"
export * from "./DocumentosMovimiento.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Proyectos\\SewayERP\\front-erpseway\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__